import React from 'react';
import Page from '../../layout/Page';
import Settings from './Settings';
import Users from './Users';
import Awards from './Awards';

const ExpressPass = ({ children, ...props }) => {

    return (
        <Page
            title='ExpressPass Management'
            icon='car'
            tabs
        >
            <Awards tab='ExpressPass' />
            {/* <Users tab='Users' /> */}
            <Settings tab='Settings' />
        </Page >
    );
}

export default ExpressPass;
